import { lazyLoad } from 'utils/loadable';

export const LoginWith2fa = lazyLoad(
  () => import('./loginWith2fa.page'),
  (module) => module.LoginWith2fa
);
